{
  "sortLabel": "Sort",
  "sortByOpen": "Open",
  "sortByOpenHint": "First to open",
  "sortByImpact": "Impact",
  "sortByImpactHint": "First to hit",
  "kindMain": "main",
  "kindStrike": "strike",
  "kindGarrison": "garrison",
  "kindMarkMain": "M",
  "kindMarkStrike": "S",
  "kindMarkGarrison": "G",
  "timeFormatHint": "Write mm:ss or mm:ss.s. Put + or - in front (e.g. -0:00.5).",
  "timeNeeded": "Enter a time",
  "timeMalformed": "That is not a time format"
}
